import { Collapse, ListItem, ListItemText, ListItemIcon, ListItemButton, Grid } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import React from "react";
import TransactionLine from "./TransactionLine";
import HistMonthPanel from "./HistMonthPanel";

export default class HistYearPanel extends React.Component {
    state = {collapseOpened:true}
    constructor(props) {
        super(props)
        this.render = this.render.bind(this)
    }

    render() {
        var trs = this.props.transactions
        var totalPlus = trs.filter(t => t.date.year() == this.props.year && t.sum>0).map(t => t.sum).reduce((sum, a) => sum+parseInt(a), 0)
        var totalMinus = -trs.filter(t => t.date.year() == this.props.year && t.sum<0).map(t => t.sum).reduce((sum, a) => sum+parseInt(a), 0)
        var total = totalPlus - totalMinus
        // console.log("year=", this.props.year, "total =", totalPlus,"-", totalMinus,"=", total)
        let months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].reverse()
        return(
            <div>
                <ListItem>
                    <ListItemButton
                        onClick={() => {
                            console.log("Open clicked")
                            this.setState({collapseOpened: !this.state.collapseOpened})
                        }
                    }
                    >
                        <Grid container>
                            <Grid item xs={2}><ListItemText>{this.props.year}</ListItemText></Grid>
                            <Grid item xs={1}><ListItemIcon>{this.state.collapseOpened ? <ExpandLess/>: <ExpandMore/>}</ListItemIcon></Grid>
                            <Grid item xs={3}/>
                            <Grid item xs={3}><ListItemText>Total=+{totalPlus}-{totalMinus}={total}</ListItemText></Grid>
                        </Grid>
                    </ListItemButton>
                    </ListItem>
                    <Collapse in={this.state.collapseOpened}>
                    {
                        months.map( (m, index) => {
                            console.log("m=", m, "index=", index)
                            return <HistMonthPanel year = {this.props.year} month={m} transactions = {this.props.transactions}
                            key = {index}
                            deleteHandle={this.props.deleteHandle} copyHandle = {this.props.copyHandle} 
                            updateHandle={this.props.updateHandle}
                            addTransToFavsHandle = {this.props.addTransToFavsHandle}/> 
                        }                   
                    )
                    }

                    </Collapse>
            </div>
        )
    }
}